<mat-nav-list
  class="nav-list"
  aria-label="Navigation bar"
  [class.horizontal]="layout === 'row'"
>
  <mat-list-item
    ><a
      matListItemTitle
      class="nav-link"
      ftE2e="navLinkTrainingPlanner"
      title="Training Planner"
      [routerLink]="['training-planner']"
    >
      <mat-icon class="nav-icon black-icon">trending_up</mat-icon>
      <span class="nav-link-text">Training Planner</span>
    </a></mat-list-item
  >

  <mat-list-item
    ><a
      matListItemTitle
      class="nav-link"
      ftE2e="navLinkExercises"
      title="Workouts"
      [routerLink]="['workouts', 'all']"
    >
      <mat-icon class="nav-icon black-icon" svgIcon="workouts"></mat-icon>
      <span class="nav-link-text">Workouts</span>
    </a></mat-list-item
  >

  <mat-list-item>
    <a
      matListItemTitle
      class="nav-link"
      ftE2e="navLinkExercises"
      title="Exercises"
      [routerLink]="['exercises', 'all']"
    >
      <mat-icon class="nav-icon" svgIcon="exercises"></mat-icon>
      <span class="nav-link-text">Exercises</span>
    </a></mat-list-item
  >

  <mat-list-item>
    <a
      matListItemTitle
      class="nav-link"
      ftE2e="navLinkCreateExercise"
      title="Create Exercise"
      [routerLink]="['exercises', 'create']"
    >
      <mat-icon class="nav-icon" svgIcon="blacksmith"></mat-icon>
      <span class="nav-link-text">Create Exercise</span>
    </a></mat-list-item
  >

  <mat-list-item *ftRoles="roles.ADMIN">
    <a
      matListItemTitle
      class="nav-link"
      ftE2e="navLinkCreateExercise"
      title="Create user"
      [routerLink]="['create-user']"
    >
      <mat-icon class="nav-icon" svgIcon="stud"></mat-icon>
      <span class="nav-link-text">Create user</span>
    </a></mat-list-item
  >
</mat-nav-list>
